import BentoGrid from "./BentoGrid";

const BentoGridWithProps = ({ blok }) => {
  return <BentoGrid rows={blok.rows} />;
};

export default BentoGridWithProps;
